import {request} from 'helpers/services/utils/request';
import {GET, POST} from 'helpers/services/constants/API_CONSTANTS';
import {
  GET_MARKETING_STATISTIC,
  POST_CONTACT_FORM_EMAIL_MARKETING,
  GET_EMAIL_MARKETING_TRIAL_DATE,
  GET_EMAIL_MARKETING_SUMMARY,
  GET_EMAIL_MARKETING_CAMPAIGNS,
  GET_EMAIL_MARKETING_CAMPAIGN_DETAIL,
  GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW
} from 'helpers/services/constants/API_ENDPOINTS';

const unwrap = (response) => {
  if (response?.data?.data !== undefined) {
    return {...response, data: response.data.data};
  }
  return response;
};

export const postContactFormApi = async (data) => {
  return request(POST, POST_CONTACT_FORM_EMAIL_MARKETING(), {data});
};

export const getStatisticApi = async (locationId) => {
  const response = await request(GET, GET_MARKETING_STATISTIC(locationId));
  return unwrap(response);
};

export const getEmailMarketingTrialDateApi = async (locationId) => {
  return request(GET, GET_EMAIL_MARKETING_TRIAL_DATE(locationId), null);
};

export const getEmailMarketingSummaryApi = async (locationId) => {
  const response = await request(GET, GET_EMAIL_MARKETING_SUMMARY(locationId));
  return unwrap(response);
};

export const getEmailMarketingCampaignsApi = async (locationId, params) => {
  const response = await request(
    GET,
    GET_EMAIL_MARKETING_CAMPAIGNS(locationId, params)
  );
  return unwrap(response);
};

export const getEmailMarketingCampaignDetailApi = async (
  locationId,
  campaignId,
  params
) => {
  const response = await request(
    GET,
    GET_EMAIL_MARKETING_CAMPAIGN_DETAIL(locationId, campaignId, params)
  );
  return unwrap(response);
};

export const getEmailMarketingCampaignPreviewApi = async (
  locationId,
  campaignId,
  params
) => {
  const response = await request(
    GET,
    GET_EMAIL_MARKETING_CAMPAIGN_PREVIEW(locationId, campaignId, params)
  );
  return unwrap(response);
};
